import { createSlice } from '@reduxjs/toolkit'

const initialState = { 
  showSideBar: true, 
  /** @deprecated Prefer `stopButtonByRun`; kept for narrow legacy callers */
  stopbutton: "", 
  /** Start / Pause / Pausing / Resume per active row: key `${processId} ${deviceId}` */
  stopButtonByRun: {} as Record<string, string>,
  tableData: [], 
  syncedData: {},
  processState: {}, 
  currentStep:{}, 
  sessionExist: null, 
  errorModalVisible:false, 
  isPausedCompleted: null, 
  pausedData: {},
  processStep: { step: "", message: "" },
  inventoryError: "",
  verificationProgress: { verifiedTag: null, totalScanned: 0 },
  unexpectedTags: [] as any[],
  verificationResults: null,
  processRunningModal: {
    visible: false,
    processName: "",
    deviceName: "",
    errorMessage: ""
  },
  currentNode: ""
}

const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSideBarState(state, action) {
      state.showSideBar = action.payload
      return state
    },

    setStopButton(state, action){
      state.stopbutton = action.payload
      return state
    },

    setStopButtonForRun(state, action) {
      const { processId, deviceId, value } = action.payload as { processId: string; deviceId: string; value: string }
      if (!processId || !deviceId) return state
      if (!state.stopButtonByRun || typeof state.stopButtonByRun !== 'object') {
        state.stopButtonByRun = {}
      }
      const key = `${processId} ${deviceId}`
      state.stopButtonByRun[key] = value
      return state
    },

    setTableData(state, action){
      state.tableData = action.payload
      return state
    },

    setProcessState(state, action){
      const {processId, deviceId, ...rest} = action.payload;
      if (!state.processState || typeof state.processState !== 'object') {
        state.processState = {}
      }
      state.processState = { ...state.processState, [`${processId} ${deviceId}`]: { ...rest } }
      return state
    },

    // setTableData(state, action){
    //   state.tableData = action.payload
    //   return state
    // },

    setSyncedData(state, action){
      state.syncedData = action.payload
      return state
    },

    setCurrentStep(state, action){
      const {processId, deviceId, step} = action.payload;
      if (!state.currentStep || typeof state.currentStep !== 'object') {
        state.currentStep = {}
      }
      state.currentStep = { ...state.currentStep, [`${processId} ${deviceId}`]: step }
      return state
    },

    setSessionExist(state, action){
      state.sessionExist = action.payload
      return state
    },

    setErrorModalVisible(state, action){
      state.errorModalVisible = action.payload
      return state
    },
    
    setIsPaused(state, action){
      state.isPausedCompleted = action.payload
      return state
    },

    setPausedData(state, action){
      state.pausedData = action.payload
      return state
    },
    resetAppData(state,_) {
      state = initialState
      return state
    },
    removeProcessState(state, action){
      if (!state.processState || typeof state.processState !== 'object') {
        state.processState = {}
      }
      const ps: Record<string, any> = { ...(state.processState as any) }
      const { processId, deviceId } = action.payload
      const key = `${processId} ${deviceId}`
      delete ps[key]
      state.processState = ps
      if (!state.stopButtonByRun || typeof state.stopButtonByRun !== 'object') {
        state.stopButtonByRun = {}
      }
      delete (state.stopButtonByRun as Record<string, string>)[key]
    },
    removeCurrentStep(state, action){
      if (!state.currentStep || typeof state.currentStep !== 'object') {
        state.currentStep = {}
      }
      const temp: any = { ...state.currentStep }
      const { processId, deviceId } = action.payload
      delete temp[`${processId} ${deviceId}`]
      state.currentStep = temp
    },

    setProcessStep(state, action){
      state.processStep = action.payload
      return state
    },

    setInventoryError(state, action){
      state.inventoryError = action.payload
      return state
    },

    setVerificationProgress(state, action){
      state.verificationProgress = action.payload
      return state
    },

    setUnexpectedTag(state, action){
      state.unexpectedTags = [...state.unexpectedTags, action.payload]
      return state
    },

    setVerificationResults(state, action){
      state.verificationResults = action.payload
      return state
    },

    setProcessRunningModal(state, action){
      // setProcessRunningModal action dispatched
      state.processRunningModal = action.payload
      return state
    },

    setCurrentNode(state, action){
      state.currentNode = action.payload
      return state
    }
  },
  extraReducers: (builder) => { }
})

export const { 
  setSideBarState,
  setStopButton,
  setStopButtonForRun,
  setTableData,
  setProcessState, 
  setSyncedData, 
  setCurrentStep, 
  setSessionExist, 
  setErrorModalVisible, 
  setIsPaused, 
  setPausedData, 
  resetAppData, 
  removeProcessState, 
  removeCurrentStep,
  setProcessStep,
  setInventoryError,
  setVerificationProgress,
  setUnexpectedTag,
  setVerificationResults,
  setProcessRunningModal,
  setCurrentNode
} = AppSlice.actions
export default AppSlice.reducer

export const selectCurrentAppState = (state: any) => state.app